import { HawaPanel } from '../types'

import component from './component.vue'
import editor from './editor.vue'

export default class ScalableVectorGraphics implements HawaPanel {
  name = 'ScalableVectorGraphics'
  title = 'SVG'
  component = component
  editor = editor
  init = {
    data: { uid: '' },
    attributes: {
      headerBackground: 'rgb(0,0,255)',
      rowEvenBackground: 'rgb(56,55,111)',
      rowOddBackground: 'rgb(118,117,179)',
      panelHeader: {
        show: false,
        style: {},
      },
    },
  }

  snapshot = { snapshot: true, attributes: {}, query: [] }
}
